import { useEffect } from 'react'
import type { ReactNode } from 'react'
import { syncRootThemeClass } from '@helpers/themeCookie'
import { useAuthSession } from '@stores/authStore'
import { useThemeStore } from '@stores/themeStore'

interface ThemeRootProps {
  children: ReactNode
}

function ThemeRoot({ children }: ThemeRootProps) {
  const session = useAuthSession()
  const themeMode = useThemeStore((state) => state.mode)
  const loadThemeMode = useThemeStore((state) => state.loadThemeMode)
  const userId = session?.user?.id ?? null
  const csrfToken = session?.csrfToken ?? null

  useEffect(() => {
    void loadThemeMode(userId, csrfToken)
  }, [csrfToken, loadThemeMode, userId])

  useEffect(() => {
    syncRootThemeClass(themeMode)
  }, [themeMode])

  return (
    <div
      className={themeMode === 'dark' ? 'dark' : ''}
      style={{ colorScheme: themeMode }}
    >
      {children}
    </div>
  )
}

export default ThemeRoot
